import { getBookingById } from "services/SauceService";

export async function bookLoader(props: any) {
  const booking: any = await getBookingById(props.params.id);

  return { booking };
}
